<template>
<div class="w-full py-4">
  <div class="text-center pb-3 font-sans font-medium text-xl">
    {{ classroom?.name }} ({{classroom?.code}})
  </div>
  <div class="flex justify-center">
    <div class="w-1/4" v-if="classroom?.must_subject_tab">
      <div class="relative mb-2">
        <div 
          class="w-10 h-10 mx-auto border-2 border-gray-200 rounded-full text-lg text-white flex items-center"
          :class="step == 1 ? 'bg-green-500' : 'bg-white' " 
        >
          <router-link :to="'/classroom/' + classroom?.id + '/step/subject'" class="text-center w-full">
            <span 
              class="text-center w-full"
              :class="step == 1 ? 'text-white' : 'text-gray-600'"
            >
              <i class="fas fa-film"></i>
            </span>
          </router-link>
        </div>
      </div>
      <div class="text-xs text-center md:text-base">Video</div>
    </div>

    <div class="w-1/4" v-if="classroom?.must_module_tab">
      <div class="relative mb-2">
        <div v-if="classroom?.must_subject_tab" class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
          <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
            <div class="w-0 bg-green-300 py-1 rounded" :style=" false ? 'width: 100%;' : 'width: 0%;'"></div>
          </div>
        </div>

        <div 
          class="w-10 h-10 mx-auto border-2 border-gray-200 rounded-full text-lg text-white flex items-center"
          :class="step == 2 ? 'bg-green-500' : 'bg-white' "   
        >
          <router-link :to="'/classroom/' + classroom?.id + '/step/modul'" class="text-center w-full">
            <span 
              class="text-center w-full"
              :class="step == 2 ? 'text-white' : 'text-gray-600'"
            >
              <i class="fas fa-book"></i>
            </span>
          </router-link>
        </div>
      </div>

      <div class="text-xs text-center md:text-base">Modul</div>
    </div>

    <div class="w-1/4" v-if="classroom?.must_webinar_tab">
      <div class="relative mb-2">
        <div v-if="(classroom?.must_webinar_tab || classroom?.must_quizzes_tab) && (classroom?.must_module_tab || classroom?.must_subject_tab)" class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
          <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
            <div class="w-0 bg-green-300 py-1 rounded" :style="false ? 'width: 100%;' : 'width: 0%;'"></div>
          </div>
        </div>

        <div 
          class="w-10 h-10 mx-auto border-2 border-gray-200 rounded-full text-lg text-white flex items-center"
          :class="step == 3 ? 'bg-green-500' : 'bg-white' " 
        >
          <router-link :to="'/classroom/' + classroom?.id + '/step/webinar'" class="text-center w-full">
            <span 
              class="text-center w-full"
              :class="step == 3 ? 'text-white' : 'text-gray-600'"
            >
              <i class="fas fa-video"></i>
            </span>
          </router-link>
        </div>
      </div>

      <div class="text-xs text-center md:text-base">Webinar</div>
    </div>

    <div class="w-1/4" v-if="classroom?.must_quizzes_tab">
      <div class="relative mb-2">
        <div v-if="classroom?.must_quizzes_tab && (classroom?.must_module_tab || classroom?.must_subject_tab || classroom?.must_webinar_tab)" class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
          <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
            <div class="w-0 bg-green-300 py-1 rounded" :style="false ? 'width: 100%;' : 'width: 0%;'"></div>
          </div>
        </div>

        <div 
          class="w-10 h-10 mx-auto border-2 border-gray-200 rounded-full text-lg text-white flex items-center"
          :class="step == 4 ? 'bg-green-500' : 'bg-white' " 
        >
          <router-link :to="'/classroom/' + classroom?.id + '/step/quiz'" class="text-center w-full">
            <span 
              class="text-center w-full"
              :class="step == 4 ? 'text-white' : 'text-gray-600'"
            >
              <i class="fas fa-tasks"></i>
            </span>
          </router-link>
        </div>
      </div>

      <div class="text-xs text-center md:text-base">Quiz</div>
    </div>

    <div class="w-1/4" v-if="classroom?.must_submission_tab">
      <div class="relative mb-2">
        <div v-if="classroom?.must_submission_tab && (classroom?.must_module_tab || classroom?.must_subject_tab || classroom?.must_webinar_tab || classroom?.must_quizzes_tab)" class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
          <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
            <div class="w-0 bg-green-300 py-1 rounded" :style="false ? 'width: 100%;' : 'width: 0%;'"></div>
          </div>
        </div>

        <div 
          class="w-10 h-10 mx-auto border-2 border-gray-200 rounded-full text-lg text-white flex items-center"
          :class="step == 5 ? 'bg-green-500' : 'bg-white' " 
        >
          <router-link :to="'/classroom/' + classroom?.id + '/step/task'" class="text-center w-full">
            <span 
              class="text-center w-full"
              :class="step == 5 ? 'text-white' : 'text-gray-600'"
            >
              <i class="fas fa-pencil-ruler"></i>
            </span>
          </router-link>
        </div>
      </div>

      <div class="text-xs text-center md:text-base">Tugas</div>
    </div>

    <div class="w-1/4">
      <div class="relative mb-2">
        <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
          <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
            <div class="w-0 bg-green-300 py-1 rounded" style="width: 0%;"></div>
          </div>
        </div>

        <div class="w-10 h-10 mx-auto bg-white border-2 border-gray-200 rounded-full text-lg text-white flex items-center">
          <div class="text-center w-full cursor-pointer" @click="finished(classroom)">
            <span class="text-center text-gray-600 w-full">
              <svg class="w-full fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path class="heroicon-ui" d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-2.3-8.7l1.3 1.29 3.3-3.3a1 1 0 0 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.42z"/>
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div class="text-xs text-center md:text-base">Finished</div>
    </div>
  </div>
</div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Step ',
  props: {
    classroom: Object,
    step: Number,
  },
  methods: {
    finished(classroom) {
      const confimation = confirm("Apakah anda yakin?")
      if(confimation) {
        this.$router.push('/classroom/' + classroom.id + '/detail')
      } else {
        return
      }
    }
  }
})
</script>